<template>
  <div class="text-center">
    <v-progress-circular
      v-show="isLoading"
      indeterminate
      color="grey"
    />
  </div>
</template>

<script>
export default {
  name: 'RaLoading',
  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>

</style>
